import { render } from "./CustomerMealReservation.vue?vue&type=template&id=1961e22e&scoped=true"
import script from "./CustomerMealReservation.vue?vue&type=script&lang=js"
export * from "./CustomerMealReservation.vue?vue&type=script&lang=js"

import "./CustomerMealReservation.vue?vue&type=style&index=0&id=1961e22e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1961e22e"]])

export default __exports__